import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import { goto } from '../../../../actions/historyActions';
import Step from '@axa-asia/emma-stylesheet/lib/components/Step/Step';
import { stringFormatter } from '../../../../utils';
import Group from '../../../../assets/images/cic-gra-7.png';
import {
  getChangeAddressLabels,
  getChangeAddressStepContext,
  getTransactionId,
  getSelectedList,
} from '../../selectors/changeAddressSelector';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import './style.scss';
import _ from 'lodash';
import { contactPermissionPolicy } from '../../types/changeContactService';
import {
  trackUpdateContactSuccess,
  TrackUpdateContactSuccessAction,
  TrackUpdateContactSuccessContent,
} from '../../../../utils/generalGaEventAnalytics';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';

export interface UpdateAddressConfirmContainerProps {
  changeAddressLabels: any;
  changeAddressStepContext: any;
  policyDetails: any;
  selectedList: contactPermissionPolicy[];
  transactionId: string;
  isUpdate: boolean;
}

export interface UpdateAddressConfirmContainerState {}

export class UpdateAddressConfirmContainer extends Component<
  UpdateAddressConfirmContainerProps,
  UpdateAddressConfirmContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { policyDetails, isUpdate } = this.props;
    if (_.isEmpty(policyDetails)) {
      goto('emma-change-contact', undefined, undefined, true);
    }
    trackUpdateContactSuccess(
      TrackUpdateContactSuccessContent.ADDRESS,
      TrackUpdateContactSuccessAction.UPDATE,
    );
  }

  onGoNext = () => {
    // const backIndex = getHistoryIndexById(CHANGE_CONTACT_ID);
    // historyGo(backIndex);
    goto('emma-change-contact');
  };

  render() {
    const { changeAddressLabels, changeAddressStepContext, transactionId } =
      this.props;
    const {
      editAddress,
      confirmTitle,
      confirmTransactionId,
      viewProfileBtn,
      confirmStepContext,
    } = changeAddressLabels;
    const resolvedStepContext = resolveLocalizedText(
      changeAddressStepContext,
    ) as any;
    const confirmStepContextList: any = confirmStepContext
      ? resolveLocalizedText(confirmStepContext)
      : {};
    const confirmStepCtxList = {
      title: '',
      list: confirmStepContextList.list,
    };
    return (
      <div className="change-address-confirm">
        <ChangeContactView
          pageName={editAddress ? resolveLocalizedText(editAddress) : ''}
          stepContext={resolvedStepContext}
          activeIndex={3}
          hideBackButton
        >
          <div className="emma-stylesheet-grid-system">
            <div className="change-address-confirm-icon">
              <img src={Group} />
            </div>
            <div className="change-address-confirm-heading">
              {confirmTitle ? resolveLocalizedText(confirmTitle) : ''}
            </div>
            <div className="change-address-confirm-step">
              <Step context={confirmStepCtxList} />
            </div>
            <div className="row">
              <button
                className="change-address-confirm-button emma-stylesheet-primary-default-button"
                data-enable-ga
                data-ga-type="button"
                onClick={this.onGoNext}
              >
                {viewProfileBtn ? resolveLocalizedText(viewProfileBtn) : ''}
              </button>
            </div>
          </div>
        </ChangeContactView>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeAddressLabels = getChangeAddressLabels(state);
    const changeAddressStepContext = getChangeAddressStepContext(state);
    const policyDetails = getSelectedPolicy(state);
    const transactionId = getTransactionId(state);

    return {
      changeAddressLabels,
      changeAddressStepContext,
      policyDetails,
      transactionId,
      isUpdate: false,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  UpdateAddressConfirmContainer.mapStateToProps,
  UpdateAddressConfirmContainer.mapDispatchToProps,
)(UpdateAddressConfirmContainer);
